import classNames from "classnames";
import React from "react";
import styles from "./TextReveal.scss";

// Longer texts take longer, within limits
const MS_PER_CHARACTER = 12;
const MIN_DURATION = 600;
const MAX_DURATION = 1800;

/**
 * Text that fades in from top to bottom. It's laid out in full from the start, so nothing moves while it appears.
 * `onDone` is called once the whole text is shown.
 */
export const TextReveal = ({ text, onDone, className }) => {
    const duration = Math.min(MAX_DURATION, Math.max(MIN_DURATION, (text?.length || 0) * MS_PER_CHARACTER));

    return (
        <div
            className={classNames(styles.base, className)}
            style={{ "--text-reveal-duration": `${duration}ms` }}
            onAnimationEnd={(event) => event.target === event.currentTarget && onDone?.()}
        >
            {text}
        </div>
    );
};
